import { SET_SCREEN_SIZE } from '../mainActionTypes';

export function setScreenSize(size) {
  return {
    type: SET_SCREEN_SIZE,
    payload: size
  };
}
